import { useState, useEffect } from 'react';
import api from '../utils/api';

export const useDashboardData = () => {
    const [stats, setStats] = useState(null);
    const [activities, setActivities] = useState([]);
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchDashboardData = async () => {
        try {
            setLoading(true);
            setError(null);

            // Fetch all dashboard data in parallel
            const [statsResponse, activitiesResponse, profileResponse] = await Promise.all([
                api.get('/dashboard/stats'),
                api.get('/dashboard/activity?limit=5'),
                api.get('/dashboard/profile')
            ]);

            console.log('Dashboard API Responses:', {
                stats: statsResponse.data,
                activities: activitiesResponse.data,
                profile: profileResponse.data
            });

            if (statsResponse.data.success) {
                console.log('Setting stats:', statsResponse.data.stats);
                setStats(statsResponse.data.stats);
            }

            if (activitiesResponse.data.success) {
                setActivities(activitiesResponse.data.activities);
            }

            if (profileResponse.data.success) {
                setProfile(profileResponse.data.profile);
            }

        } catch (error) {
            console.error('Dashboard data fetch error:', error);
            setError(error.response?.data?.message || 'Failed to load dashboard data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const refreshData = () => {
        fetchDashboardData();
    };

    return {
        stats,
        activities,
        profile,
        loading,
        error,
        refreshData
    };
};
